<template>
  <div>
    <template v-if="!hasVoucherCode">
      <v-layout>
        <v-flex
          :class="pageProfile && pageProfile.egg_crm_status ? '' : 'my-input'"
        >
          <v-text-field
            outline
            :color="theme.color"
            v-model="promocode"
            :label="$t('Input voucher code')"
            :disabled="loading"
            :hide-details="!hasError"
            maxlength="20"
            :error="hasError"
            :error-messages="hasError ? this.errorVoucherCode : ''"
            @keypress.enter="$refs.voucherBtn.$el.click()"
          ></v-text-field>
        </v-flex>
        <v-flex shrink>
          <v-btn
            ref="voucherBtn"
            style="color: #ffffff"
            :color="theme.color"
            @click="onCheckVoucher()"
            :disabled="!promocode || promocode == ''"
            :loading="loading"
          >
            {{ $t('Apply') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <div class="mb-2 flex-overflow" style="place-content: center">
        <div class="text-xs-center">
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on }">
              <v-btn
                small
                outline
                v-on="on"
                :disabled="codeAll.length === 0"
                :color="theme.color"
              >
                {{ $t('Select voucher code') }}
                {{ codeAll.length !== 0 ? '(' + codeAll.length + ')' : '' }}
              </v-btn>
              <v-btn
                v-if="pageProfile && pageProfile.egg_crm_status"
                small
                outline
                :color="theme.color"
                @click="openRedeem"
              >
                {{ $t('แลกรางวัล') }}
              </v-btn>
            </template>

            <v-card outline>
              <div style="float: right">
                <v-btn fab flat small @click="dialog = false">
                  <v-icon>mdi-close</v-icon></v-btn
                >
              </div>
              <v-card-title class="headline lighten-2" primary-title>
                <div>{{ $t('Select voucher code') }}</div>
              </v-card-title>
              <template v-for="(code, i) in codeAll">
                <v-card
                  class="ma-3"
                  :style="
                    code.promotype === 'piece'
                      ? 'border-left: solid 3px orange'
                      : 'border-left: solid 3px cyan'
                  "
                  :key="i"
                >
                  <v-card-text class="pa-2">
                    <v-layout>
                      <v-flex>
                        <v-card-text>
                          <span class="caption"
                            >{{ $t('Minimum purchase of') }}
                          </span>
                          <span
                            class="caption"
                            :class="{
                              'cyan--text lighten-2': code.promotype == 'price',
                              'orange--text lighten-2':
                                code.promotype == 'piece'
                            }"
                          >
                            <template v-if="code.promotype == 'price'">
                              {{ code.promovalue | numberFormat }}
                              {{ $t('Baht') }}
                            </template>
                            <template v-else
                              >{{ code.promovalue | numberFormat }}
                              {{ $t('Items') }}
                            </template>
                          </span>
                          <div class="caption">
                            <template v-if="code.discounttype == 'price'">
                              {{ $t('Discount price') }}
                              {{ code.discountvalue | numberFormat }}
                              {{ $t('Baht') }}
                            </template>
                            <template
                              v-else-if="code.discounttype == 'percent'"
                            >
                              {{ $t('Discount percent') }}
                              {{ code.discountvalue }} %
                              <span
                                v-if="
                                  code.maximum_discount_value &&
                                  code.maximum_discount_value > 0
                                "
                                >( {{ $t('maximum_discount') }}
                                {{ code.maximum_discount_value }}
                                {{ $t('Baht') }} )</span
                              >
                            </template>
                            <template v-else-if="code.discounttype == 'ship'">
                              {{ $t('Discount shipping fee') }}
                              {{ code.discountvalue | numberFormat }}
                              {{ $t('Baht') }}
                            </template>
                            <template
                              v-else-if="code.discounttype == 'freeship'"
                            >
                              {{ $t('Free Delivery') }}
                            </template>
                          </div>
                          <div class="mb-2">
                            <span
                              class="primary--text"
                              style="text-transform: uppercase"
                              >{{ code.code }}</span
                            >
                          </div>
                        </v-card-text>
                      </v-flex>
                      <v-btn
                        :color="theme.color"
                        small
                        dark
                        class="ma-0"
                        @click="selectPromoCode(code.code)"
                      >
                        {{ $t('Use') }}
                      </v-btn>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </template>
              <v-divider></v-divider>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </template>
    <template v-else-if="hasVoucherCode && promotion">
      <v-card
        class="mb-3"
        style="border-left: 4px solid"
        :style="{ 'border-color': theme.color }"
      >
        <v-card-text>
          <v-layout>
            <v-flex>
              <div
                :style="
                  pageProfile && pageProfile.egg_crm_status
                    ? ''
                    : 'text-transform: uppercase;'
                "
              >
                {{ promocode }}
              </div>
              <div class="title mt-1" :style="{ color: theme.color }">
                <template v-if="promotion.freeship">
                  {{ $t('Free Delivery') }}
                  {{
                    exceptCashOnDelivery ? $t('Except cash on delivery') : ''
                  }}
                </template>
                <template v-else-if="promotion.discountship > 0">
                  {{ $t('Discount Shipping Fee') }} {{ currencySign
                  }}{{ promotion.discountship }}
                </template>
                <template v-else-if="promotion.discount > 0 && !promotion.sku">
                  {{ $t('Discount') }} {{ currencySign
                  }}{{ promotion.discount }}
                </template>
                <template v-if="promotion.sku">
                  <v-layout
                    class="product"
                    v-if="
                      promotion &&
                      promotion.sku &&
                      promotion.sku.data &&
                      promotion.sku.product
                    "
                  >
                    <v-flex xs3 sm2 class="product-img">
                      <v-img
                        :src="promotion.sku.product.photourl"
                        alt="product.sku.product.name"
                        class="img-responsive"
                        lazy
                        aspect-ratio="1"
                      />
                    </v-flex>
                    <v-flex xs9 sm10 class="detail pl-2 pr-2">
                      <!-- <div class="name small">
                        แถม
                      </div> -->

                      <p class="price">
                        <template>
                          {{ promotion.sku.product.name }} x
                          {{ promotion.sku.data.quantity }}
                        </template>
                      </p>
                      <div>
                        {{ $t('Discount') }} {{ currencySign
                        }}{{ promotion.discount | decimalFormat }}
                      </div>
                    </v-flex>
                  </v-layout>
                </template>
                <template v-if="giveAwayProducts && giveAwayProducts.length">
                  {{ $t('โปรดเลือกของแถมด้านล่าง') }}
                </template>
              </div>
            </v-flex>
            <v-flex shrink>
              <v-btn
                fab
                flat
                small
                icon
                @click="clearpromocodeincart"
                :loading="loading"
              >
                <v-icon small>mdi-close</v-icon></v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-text>

        <template v-if="giveAwayProducts && giveAwayProducts.length">
          <v-divider />
          <v-card-text>
            <SelectGiveAwayProduct
              v-model="selectedGiveAwayProduct"
              :giveAwayProducts="giveAwayProducts"
              @handleSelectGiveAwayProduct="handleSelectGiveAwayProduct"
            />

            <slot
              name="append"
              v-bind="{
                hasGiveAways: giveAwayProducts && giveAwayProducts.length
              }"
            ></slot>
          </v-card-text>
        </template>
      </v-card>
    </template>
  </div>
</template>

<script>
import VoucherCodeMixin from './VoucherCodeMixin.js'
import { mapGetters } from 'vuex'
import SelectGiveAwayProduct from './SelectGiveAwayProduct'
export default {
  mixins: [VoucherCodeMixin],
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  },
  components: {
    SelectGiveAwayProduct
  },
  methods: {
    onBlur(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122)
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    handleSelectGiveAwayProduct(item) {
      this.$emit('handleSelectedGiveAwayProduct', item)
    }
  }
}
</script>

<style lang="scss">
.my-input input {
  text-transform: uppercase;
}
.flex-overflow {
  display: flex;
  overflow-y: overlay;
}
</style>
